import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownTextProps {
  text: string;
  children?: never;
}

/**
 * Renders underwriting rule text written in Markdown (headings, lists, emphasis, links, tables). react-markdown
 * never emits raw HTML from the source, so rule text authored in the workbench cannot inject markup.
 */
export function MarkdownText({ text }: MarkdownTextProps) {
  return (
    <div className="markdown text-sm leading-relaxed text-gray-700 [&_a]:text-brand-navy [&_a]:underline [&_code]:rounded [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:font-mono [&_code]:text-xs [&_h1]:mb-1 [&_h1]:text-base [&_h1]:font-semibold [&_h1]:text-gray-800 [&_h2]:mb-1 [&_h2]:text-sm [&_h2]:font-semibold [&_h2]:text-gray-800 [&_h3]:mb-1 [&_h3]:text-sm [&_h3]:font-semibold [&_li]:my-0.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-1.5 [&_strong]:font-semibold [&_strong]:text-gray-800 [&_table]:my-2 [&_table]:text-xs [&_td]:border [&_td]:border-gray-200 [&_td]:px-2 [&_td]:py-1 [&_th]:border [&_th]:border-gray-200 [&_th]:bg-gray-50 [&_th]:px-2 [&_th]:py-1 [&_ul]:list-disc [&_ul]:pl-5">
      <Markdown remarkPlugins={[remarkGfm]}>{text}</Markdown>
    </div>
  );
}
